// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8LEZj {\n  overflow: hidden;\n}\n\n  .S2917 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: normal;\n    word-break: break-word;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MultiLineEllipsisText": "_8LEZj",
	"MultiLineEllipsisText_textContainer": "S2917"
};
export default ___CSS_LOADER_EXPORT___;
